exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal-footer .btn+.btn{margin-left:0}", "", {"version":3,"sources":["/app/src/components/master/sellingTariff/AncillaryRate.vue"],"names":[],"mappings":"AACA,wBACE,aAAe,CAChB","file":"AncillaryRate.vue","sourcesContent":["\n.modal-footer .btn + .btn {\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6480cfc6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/sellingTariff/AncillaryRate.vue
// module id = 1006
// module chunks = 27